export type BulletinPdfFontFamily = "serif" | "sans";
export type BulletinPdfFontWeight = "normal" | "bold";

export interface BulletinPdfFontOptions {
  family?: BulletinPdfFontFamily;
  weight?: BulletinPdfFontWeight;
  italic?: boolean;
  fontSize?: number;
  color?: [number, number, number];
}

export const getBulletinPdfFontStyle = ({
  family = "sans",
  weight = "normal",
  italic = false,
}: BulletinPdfFontOptions) => {
  const resolvedFamily = "helvetica";
  const isBold = weight === "bold";

  // Match the preview styling without forcing Times New Roman or italic text in the PDF export.
  if (italic) return { family: resolvedFamily, style: isBold ? "bold" : "normal" };
  if (isBold) return { family: resolvedFamily, style: "bold" };

  return { family: resolvedFamily, style: "normal" };
};

export const applyBulletinPdfTextStyle = (
  doc: { setFont: (fontName: string, style: string) => void; setFontSize: (size: number) => void; setTextColor: (r: number, g: number, b: number) => void; },
  options: BulletinPdfFontOptions = {},
) => {
  const { family, weight, italic, fontSize, color } = options;
  const { family: resolvedFamily, style } = getBulletinPdfFontStyle({ family, weight, italic });

  doc.setFont(resolvedFamily, style);
  if (typeof fontSize === "number") doc.setFontSize(fontSize);
  if (color) doc.setTextColor(color[0], color[1], color[2]);
};
